import { useLocalSearchParams } from 'expo-router';

import PaymentHistory from '../../../../banking/components/spaces/transactions/PaymentHistory';

const PaymentHistoryScreen = () => {
    const { syncteraAccountId } = useLocalSearchParams<{
        syncteraAccountId: string;
    }>();

    return <PaymentHistory syncteraAccountId={syncteraAccountId} />;
};

export default PaymentHistoryScreen;
